
<v-autocomplete
    :label             = "$t('disposition.inspection.technician.label')"
    :items             = "dispatcher"
    item-value         = "id"
    item-text          = "name"
    v-model            = "user"
    :return-object     = true
    :clearable         = "true"
    :auto-select-first = "true"
    :outlined          = "outlined"
    :dense             = "dense"
    hide-details
    flat
    hide-no-data
    autocomplete  = "off"
    autocorrect   = "off"
    autocapitalize= "off"
    spellcheck    = "false"
    @input = "onInput"
>
</v-autocomplete>
